module.exports = "<div class=\"row\"><div class=\"col s1\"><p class=\"ranking\">ranking</p></div><div class=\"col s9\"><div id=\"bars\"></div></div><div class=\"col s2\"><a href=\"assets/data/coeficienteTAI.csv\" download=\"\" target=\"_blank\"> <img class=\"responsive-img\" style=\"max-width: 50px; margin-right: 8px; margin-top: 30px;\" src=\"assets/images/btn_datos_{{topic}}.svg\" alt=\"Datos\" title=\"DATOS\"/></a></div></div>"


//////////////////
// WEBPACK FOOTER
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxBars/dboxBars.component.html
// module id = ../../../../../src/app/dboxBars/dboxBars.component.html
// module chunks = main